<app-page-header
  class="header"
  coreActivitySection="Header"
  coreUserActivityClickTracking="CloseBearTab"
  [backSwipe]="backSwipeConfig"
  [routerLink]="['/main', 'home']"
/>

@if (loading()) {
  <app-loading/>
} @else {
  @let new = this.new();

  @if (new && new.length > 0) {
    <swiper-container
      class="swiper"
      [autoplay]="false"
      [pagination]="true"
      [direction]="'vertical'"
      [loop]="true"
    >
      @for (slide of new; track slide.id; let i = $index) {
        @if (slide.contentType === 'image') {
          <swiper-slide>
            <img class="slide" [src]="slide.contentLocal" alt="Promo {{ i + 1 }}"/>
          </swiper-slide>
        } @else if (slide.contentType === 'video') {
          <swiper-slide>
            <video swiperControl class="slide" autoplay muted loop [src]="slide.contentLocal"></video>
          </swiper-slide>
        }
      }
    </swiper-container>
  } @else {
    <div class="empty">
      No available at this time.
    </div>
  }
}
